export interface Comic {
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  rating: number;
  ratingCount: number;
  tags: string[];
  summary: string;
  status: '连载中' | '已完结';
  updateInfo: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    slug: 'the-remarried-empress',
    title: '再婚皇后',
    author: 'Alphatart / Sumpul',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20an%20elegant%20queen%20with%20long%20flowing%20hair%20wearing%20a%20regal%20golden%20gown%2C%20soft%20watercolor%20background%20with%20warm%20tones%2C%20romantic%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20composition%20on%20light%20cream%20backdrop&width=600&height=800&seq=comic-remarried-empress&orientation=portrait',
    category: 'love',
    rating: 4.8,
    ratingCount: 32500,
    tags: ['宫廷', '恋爱', '逆袭', '女性向'],
    summary: '皇后娜菲尔在离婚后选择再婚，她的选择震惊了整个帝国。面对前夫的后悔和新婚丈夫的宠爱，她将如何书写自己的命运？',
    status: '连载中',
    updateInfo: '更新至第 185 话',
    views: 12800000,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20dark%20haired%20Korean%20manhwa%20character%20with%20purple%20glowing%20eyes%20and%20shadow%20army%20behind%20him%2C%20action%20pose%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20clean%20composition%20on%20dark%20gradient%20backdrop&width=600&height=800&seq=comic-solo-leveling&orientation=portrait',
    category: 'action',
    rating: 4.9,
    ratingCount: 89500,
    tags: ['战斗', '升级', '魔幻', '热血'],
    summary: '被称作"人类最弱兵器"的成振宇，在一次双重地下城事件后获得了"系统"，从此开启了不断变强的道路。',
    status: '已完结',
    updateInfo: '全 179 话已完结',
    views: 56000000,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20tall%20tower%20reaching%20into%20the%20sky%20with%20a%20young%20boy%20climbing%20its%20stairs%2C%20fantasy%20Korean%20webtoon%20art%20style%2C%20magical%20atmosphere%20with%20sparkles%2C%20clean%20composition%20on%20light%20gradient%20backdrop&width=600&height=800&seq=comic-tower-god&orientation=portrait',
    category: 'fantasy',
    rating: 4.7,
    ratingCount: 45600,
    tags: ['冒险', '奇幻', '成长', '友情'],
    summary: '二十五夜为了追寻青梅竹马蕾哈尔而进入神之塔，在这里他遇到了各种伙伴和考验，一步步向塔顶攀登。',
    status: '连载中',
    updateInfo: '更新至第 620 话',
    views: 35000000,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20face%20Korean%20webtoon%20illustration%20showing%20contrast%20between%20handsome%20and%20plain%20appearance%2C%20modern%20school%20setting%2C%20dramatic%20lighting%2C%20stylized%20manhwa%20art%2C%20clean%20composition%20on%20neutral%20backdrop&width=600&height=800&seq=comic-lookism&orientation=portrait',
    category: 'drama',
    rating: 4.6,
    ratingCount: 28900,
    tags: ['校园', '双面人生', '成长', '社会'],
    summary: '朴亨硕因为外貌在学校遭受霸凌，转学后却发现自己能够使用另一具完美身体，从此开启了双面人生。',
    status: '连载中',
    updateInfo: '更新至第 478 话',
    views: 22000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'who-made-me-a-princess',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20princess%20with%20long%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20a%20pink%20royal%20dress%2C%20surrounded%20by%20flowers%2C%20soft%20dreamy%20atmosphere%2C%20romantic%20manhwa%20style%2C%20clean%20composition%20on%20light%20cream%20backdrop&width=600&height=800&seq=comic-princess&orientation=portrait',
    category: 'love',
    rating: 4.8,
    ratingCount: 42100,
    tags: ['穿越', '父女', '治愈', '皇室'],
    summary: '一觉醒来变成了小说中注定死亡的公主阿西娅，为了改变命运，她决定攻略那个冷酷无情的父皇克劳德。',
    status: '已完结',
    updateInfo: '全 125 话已完结',
    views: 31000000,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'the-boxer',
    title: '拳击手',
    author: 'JH',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20Korean%20manhwa%20boxer%20with%20intense%20eyes%20wearing%20boxing%20gloves%2C%20dramatic%20lighting%2C%20action%20pose%20in%20the%20ring%2C%20dark%20atmosphere%2C%20gritty%20art%20style%2C%20clean%20composition&width=600&height=800&seq=comic-boxer&orientation=portrait',
    category: 'action',
    rating: 4.5,
    ratingCount: 18900,
    tags: ['体育', '拳击', '热血', '成长'],
    summary: '一个拥有非凡天赋的少年被传奇教练发现，踏上了职业拳击的道路。在拳台上，他将面对各种强大的对手。',
    status: '已完结',
    updateInfo: '全 123 话已完结',
    views: 15000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'true-beauty',
    title: '女神降临',
    author: 'Yaongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20girl%20with%20perfect%20makeup%20and%20long%20dark%20hair%2C%20holding%20cosmetics%2C%20modern%20school%20setting%2C%20bright%20and%20cheerful%20atmosphere%2C%20romantic%20comedy%20vibe%2C%20clean%20composition%20on%20light%20pink%20backdrop&width=600&height=800&seq=comic-true-beauty&orientation=portrait',
    category: 'comedy',
    rating: 4.4,
    ratingCount: 35600,
    tags: ['化妆', '校园', '恋爱', '喜剧'],
    summary: '因为长相被欺负的林周京，通过化妆成为校园女神，但她最害怕的事情就是被人看到自己的素颜。',
    status: '已完结',
    updateInfo: '全 223 话已完结',
    views: 28000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20apocalyptic%20Korean%20webtoon%20scene%20with%20monsters%20lurking%20in%20shadows%20of%20an%20apartment%20building%2C%20horror%20atmosphere%2C%20survival%20theme%2C%20dark%20moody%20lighting%2C%20thriller%20manhwa%20style%2C%20clean%20composition&width=600&height=800&seq=comic-sweet-home&orientation=portrait',
    category: 'thriller',
    rating: 4.7,
    ratingCount: 31200,
    tags: ['惊悚', '末日', '怪物', '生存'],
    summary: '在公寓被怪物包围的末日世界里，性格孤僻的贤秀与邻居们一起为了生存而战斗，人性的考验才刚刚开始。',
    status: '已完结',
    updateInfo: '全 140 话已完结',
    views: 20000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'eleceed',
    title: '超能觉醒',
    author: '孙济好 / ZHENA',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20fat%20cat%20with%20electric%20powers%20in%20Korean%20webtoon%20style%20next%20to%20a%20young%20male%20protagonist%2C%20action%20adventure%20theme%2C%20bright%20colorful%20atmosphere%2C%20humor%20and%20action%20blend%2C%20clean%20composition&width=600&height=800&seq=comic-eleceed&orientation=portrait',
    category: 'fantasy',
    rating: 4.8,
    ratingCount: 37800,
    tags: ['异能', '猫', '热血', '搞笑'],
    summary: '拥有超能力的少年纪元与一只会发电的肥猫相遇后，被卷入了一个充满异能者的隐藏世界。',
    status: '连载中',
    updateInfo: '更新至第 300 话',
    views: 19000000,
    isHot: true,
    isNew: false,
  },
  {
    slug: 'killing-stalking',
    title: '杀戮跟踪',
    author: 'Koogi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20psychological%20Korean%20manhwa%20illustration%20with%20two%20male%20figures%20in%20tense%20atmosphere%2C%20shadows%20and%20silhouettes%2C%20horror%20thriller%20vibe%2C%20moody%20lighting%2C%20clean%20composition%20on%20dark%20backdrop&width=600&height=800&seq=comic-killing-stalking&orientation=portrait',
    category: 'thriller',
    rating: 4.3,
    ratingCount: 28900,
    tags: ['心理', '悬疑', 'BL', '黑暗'],
    summary: '尹范在暗恋对象尚宇家中发现了一个惊人的秘密，从此他的生活陷入了无法逃脱的黑暗深渊。',
    status: '已完结',
    updateInfo: '全 67 话已完结',
    views: 12000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'the-beginning-after-the-end',
    title: '末世之后',
    author: 'TurtleMe / Fuyuki23',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20wielding%20magic%20in%20a%20fantasy%20world%20Korean%20webtoon%20illustration%2C%20sword%20and%20magic%20theme%2C%20medieval%20fantasy%20setting%2C%20warm%20golden%20lighting%2C%20adventure%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-beginning-end&orientation=portrait',
    category: 'fantasy',
    rating: 4.6,
    ratingCount: 22300,
    tags: ['重生', '魔法', '冒险', '奇幻'],
    summary: '曾经的王者格雷在死后重生为一个婴儿，在新世界中他决定保护所爱之人，不再重复前世的遗憾。',
    status: '连载中',
    updateInfo: '更新至第 195 话',
    views: 16000000,
    isHot: false,
    isNew: true,
  },
  {
    slug: 'cherry-blossoms-after-winter',
    title: '冬后樱花',
    author: 'Bamwoo',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20young%20Korean%20manhwa%20male%20characters%20standing%20under%20cherry%20blossom%20trees%2C%20soft%20spring%20atmosphere%2C%20romantic%20BL%20vibe%2C%20gentle%20warm%20lighting%2C%20clean%20composition%20on%20light%20pink%20backdrop&width=600&height=800&seq=comic-cherry-blossom&orientation=portrait',
    category: 'bl',
    rating: 4.6,
    ratingCount: 15600,
    tags: ['BL', '校园', '青梅竹马', '温情'],
    summary: '海春和泰成从小一起长大，从朋友到恋人的转变让两人的关系经历了甜蜜与考验。冬去春来，樱花终会绽放。',
    status: '已完结',
    updateInfo: '全 146 话已完结',
    views: 9800000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'a-business-proposal',
    title: '社内相亲',
    author: '海花 / Narak',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20handsome%20CEO%20and%20a%20pretty%20office%20worker%20in%20a%20romantic%20Korean%20webtoon%20scene%2C%20modern%20office%20setting%2C%20romantic%20comedy%20atmosphere%2C%20bright%20warm%20lighting%2C%20clean%20composition%20on%20light%20cream%20backdrop&width=600&height=800&seq=comic-business-proposal&orientation=portrait',
    category: 'comedy',
    rating: 4.5,
    ratingCount: 21300,
    tags: ['办公室', '恋爱', '喜剧', '契约'],
    summary: '替闺蜜去相亲的申夏莉，没想到相亲对象竟然是自己公司的社长姜泰武！一场契约恋爱就此展开。',
    status: '已完结',
    updateInfo: '全 124 话已完结',
    views: 17500000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'under-the-oak-tree',
    title: '橡树下',
    author: '金秀智 / P',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20medieval%20fantasy%20Korean%20webtoon%20scene%20with%20a%20knight%20and%20a%20noble%20lady%20under%20a%20large%20oak%20tree%2C%20romantic%20fantasy%20setting%2C%20warm%20golden%20afternoon%20light%2C%20soft%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-oak-tree&orientation=portrait',
    category: 'love',
    rating: 4.7,
    ratingCount: 24600,
    tags: ['骑士', '贵族', '恋爱', '成长'],
    summary: '公爵千金马克西米利安被迫嫁给骑士利夫坦，在这段不被看好的婚姻中，两个受伤的灵魂逐渐靠近。',
    status: '连载中',
    updateInfo: '更新至第 98 话',
    views: 14200000,
    isHot: false,
    isNew: true,
  },
  {
    slug: 'light-and-shadow',
    title: '光与影',
    author: '柳和水 / 熙媛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20medieval%20Korean%20webtoon%20duke%20and%20duchess%20in%20elegant%20attire%2C%20dramatic%20lighting%20with%20shadow%20contrast%2C%20historical%20romance%20theme%2C%20regal%20atmosphere%2C%20clean%20composition%20on%20dark%20warm%20backdrop&width=600&height=800&seq=comic-light-shadow&orientation=portrait',
    category: 'historical',
    rating: 4.5,
    ratingCount: 18200,
    tags: ['古风', '权谋', '恋爱', '复仇'],
    summary: '身为女仆的艾德娜隐藏身份嫁给了公爵，她必须在复仇与爱情之间做出抉择。光明与阴影交织的命运之舞。',
    status: '已完结',
    updateInfo: '全 103 话已完结',
    views: 11000000,
    isHot: false,
    isNew: false,
  },
  {
    slug: 'omniscient-reader',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20protagonist%20reading%20a%20book%20while%20the%20apocalyptic%20world%20collapses%20around%20him%2C%20dramatic%20contrast%2C%20fantasy%20survival%20theme%2C%20intense%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-omniscient&orientation=portrait',
    category: 'fantasy',
    rating: 4.9,
    ratingCount: 52100,
    tags: ['末世', '系统', '生存', '智斗'],
    summary: '当连载了十年的小说变成现实，唯一读完结局的金独子成为了这个末日世界中最特殊的存在——全知读者。',
    status: '连载中',
    updateInfo: '更新至第 230 话',
    views: 42000000,
    isHot: true,
    isNew: false,
  },
];

export const getComicsByCategory = (category: string) =>
  comics.filter((c) => c.category === category);

export const getHotComics = () => comics.filter((c) => c.isHot);

export const getNewComics = () => comics.filter((c) => c.isNew);

export const getComicBySlug = (slug: string) =>
  comics.find((c) => c.slug === slug);